export namespace DateHelpers {
    export function addDays(base: Date, days: number): Date {
        const d = new Date(base);
        d.setDate(d.getDate() + days);
        return d;
    }

    export function toYMD(d: Date): string {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    export function brDate(d: Date): string {
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }

    export function brDateYMD(ymd: string): string {
        if (!ymd) return '';
        const [y, m, d] = ymd.split('-');
        return `${d}/${m}/${y}`;
    }
}